import { versions } from './../../../environments/versions';
import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'qw-debug-page',
    templateUrl: './debug-page.component.html',
    styleUrls: ['./debug-page.component.scss'],
    standalone: true,
    imports: [FaIconComponent, DatePipe],
})
export class DebugPageComponent {
    versionInfo = versions;

    throwException() {
        const randomNumber = Math.random() * 10000;
        throw Error(`Test error: ${new Date()} ${randomNumber}`);
    }
}
